import { render, staticRenderFns } from "./DeleteMember.vue?vue&type=template&id=36a10f80&"
import script from "./DeleteMember.vue?vue&type=script&lang=js&"
export * from "./DeleteMember.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports